import api from '@pray/shared/utils/api';

export async function updateLeadCampaign({
  id: campaignId,
  name,
  title,
  subtitle,
  disclaimer,
  buttonText,
  imageUrl,
  type,
  targetCount,
  allocationMode,
  autopopulatePhoneNumber,
  scheduledStartDate,
  scheduledEndDate,
  dailyTargetLimit,
  popupEnabled,
  adUnitDescription,
  adUnitButtonText,
  placements,
  platforms,
  offerId,
  leadClientId,
}) {
  if (!campaignId) throw Error('Campaign ID is required');

  const data = {};

  if (name !== undefined) data.name = name;
  if (title !== undefined) data.title = title;
  if (subtitle !== undefined) data.subtitle = subtitle;
  if (disclaimer !== undefined) data.disclaimer = disclaimer;
  if (buttonText !== undefined) data.button_text = buttonText;
  if (imageUrl !== undefined) data.image_url = imageUrl;
  if (type !== undefined) data.type = type;
  // Turning a campaign open-ended retires its target, so send the null explicitly even when the
  // caller passed no count. Leaving it undefined drops the key on serialization and the old number
  // survives, which is how the legacy 999999 values would have outlived the switch.
  if (allocationMode === 'open_ended') data.target_count = null;
  else if (targetCount !== undefined) data.target_count = targetCount;
  if (allocationMode !== undefined) data.allocation_mode = allocationMode;
  if (autopopulatePhoneNumber !== undefined) data.auto_populate_phone_number = autopopulatePhoneNumber;
  if (scheduledStartDate !== undefined) data.scheduled_start_date = scheduledStartDate;
  if (scheduledEndDate !== undefined) data.scheduled_end_date = scheduledEndDate;
  if (dailyTargetLimit !== undefined) data.daily_target_limit = dailyTargetLimit;
  if (popupEnabled !== undefined) data.popup_enabled = popupEnabled;
  if (adUnitButtonText !== undefined) data.ad_unit_button_text = adUnitButtonText;
  if (adUnitDescription !== undefined) data.ad_unit_description = adUnitDescription;
  if (Array.isArray(placements)) data.placements = placements;
  if (Array.isArray(platforms)) data.platforms = platforms;
  if (offerId !== undefined) data.offer_id = offerId;
  // Remaps the campaign to a different integration (LeadClient). The PUT schema
  // treats this as optional; sending the current value is a no-op remap.
  if (leadClientId !== undefined) data.lead_client_id = leadClientId;

  const url = `/web/studio/lead-campaigns/${campaignId}`;
  const response = await api.executePutRequest(url, data);

  return response.data;
}
